import { isBoolean, isEqual, isFunction, noop } from 'lodash-es';
import type { Recordable } from '@mts-fe/types';

export {
  isBoolean,
  isEmpty,
  isFunction,
  isMap,
  isNil,
  isNull,
  isNumber,
  isPlainObject,
  isString,
  isWeakMap,
  isWeakSet,
  noop,
} from 'lodash-es';

export const unrealized = (...args) => (console.warn('方法未实现'), noop(...args));

const toString = Object.prototype.toString;
export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`;
}
export function isDef<T = unknown>(val?: T): val is T {
  return typeof val !== 'undefined';
}
export const isObject = (val: unknown): val is Record<any, any> =>
  val !== null && typeof val === 'object';
export const isArray = Array.isArray;
export const isStringArray = (arr: unknown) => {
  return isArray(arr) && arr.every((i) => typeof i === 'string');
};

/**
 * 使用 JSON.stringify 进行深度比较
 * @returns {boolean} 是否相等
 */
export function isEqualByStringify(value: unknown, oldValue: unknown): boolean {
  if (value === oldValue) return true;

  try {
    return JSON.stringify(value) === JSON.stringify(oldValue);
  } catch (error) {
    return isEqual(value, oldValue);
  }
}

export const inBrowser = typeof window !== 'undefined';
export function isWindow(val: any): val is Window {
  return typeof window !== 'undefined' && is(val, 'Window');
}

export function isHttpUrl(path: string): boolean {
  if (typeof path !== 'string' || path.length < 8) return false;

  if (!path.startsWith('http://') && !path.startsWith('https://')) return false;

  const reg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
  return reg.test(path);
}

export function isPascalCase(str: string): boolean {
  const regex = /^[A-Z][A-Za-z]*$/;
  return regex.test(str);
}

export function isIfShow<T>(
  action: T & { ifShow?: boolean | ((action: T, globalParams: Recordable) => boolean) },
  globalParams: Recordable,
): boolean {
  const ifShow = action.ifShow;

  let isIfShow = true;
  if (isBoolean(ifShow)) {
    isIfShow = ifShow;
  }
  if (isFunction(ifShow)) {
    isIfShow = ifShow(action, globalParams);
  }
  return isIfShow;
}
